import React from 'react';
import { PageHeader } from '../components/PageHeader';
import { SectionPager } from '../components/SectionPager';
import { Competencies } from '../components/Competencies';
export function Expertise() {
  return <>
      <PageHeader number="04" title="Core Competencies" blurb="Four pillars behind every portfolio built, repositioned, and scaled." data-id="element-270" data-mp="24cdj7fjvrgks" />
      <Competencies data-id="element-271" data-mp="1bmn3j22lo6mk" />
      <SectionPager current="/expertise" data-id="element-272" data-mp="1bngdsd0rpe9g" />
    </>;
}